var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('a-spin', {
    attrs: {
      "spinning": _vm.loading
    }
  }, [_c('a-row', {
    attrs: {
      "gutter": 16
    }
  }, [_c('a-col', {
    attrs: {
      "span": 24
    }
  }, [_c('h5', {
    staticClass: "mb-1"
  }), _c('a-form', {
    attrs: {
      "layout": "inline"
    }
  }, [_c('a-form-item', {
    attrs: {
      "help": _vm._trs('Delivery date')
    }
  }, [_c('a-date-picker', {
    attrs: {
      "placeholder": _vm._trs('Select date'),
      "valueFormat": "YYYY-MM-DD"
    },
    on: {
      "change": _vm.getHoursForDate
    },
    model: {
      value: _vm.date,
      callback: function callback($$v) {
        _vm.date = $$v;
      },
      expression: "date"
    }
  })], 1), _c('a-form-item', [_c('a-select', {
    staticStyle: {
      "min-width": "80px"
    },
    on: {
      "change": _vm.search
    },
    model: {
      value: _vm.hour,
      callback: function callback($$v) {
        _vm.hour = $$v;
      },
      expression: "hour"
    }
  }, _vm._l(_vm.hours, function (timeStep) {
    return _c('a-select-option', {
      key: timeStep.id,
      attrs: {
        "value": timeStep.id
      }
    }, [_vm._v(" " + _vm._s(timeStep.label) + " ")]);
  }), 1)], 1), _c('a-form-item', [_c('a-button', {
    staticClass: "btn btn-success",
    on: {
      "click": _vm.search
    }
  }, [_vm._v(_vm._s(_vm._trs('Get results')))])], 1)], 1), _c('p', {
    staticClass: "font-weight-light mb-3"
  }), _c('p', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.price != null,
      expression: "price != null"
    }],
    staticClass: "text-center",
    staticStyle: {
      "font-size": "18px"
    }
  }, [_c('span', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm._trs('Price')) + ":")]), _c('span', {
    staticClass: "text-bold mr-3"
  }, [_vm._v(_vm._s(_vm.price) + " €/MWh")]), _c('span', {
    staticClass: "mr-1"
  }, [_vm._v(_vm._s(_vm._trs('Volume')) + ":")]), _c('span', {
    staticClass: "text-bold"
  }, [_vm._v(_vm._s(_vm.volume) + " MWh")])]), _c('div', {
    staticClass: "mb-10",
    staticStyle: {
      "height": "450px"
    },
    attrs: {
      "id": "bid-ask-curve-chart"
    }
  })], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }